module.exports = __webpack_public_path__ + "img/EFFIZIENT.3145a9e8.png";